/**
 * @flow
 * @format
 */

/**
 * Simple function to collapse react children.
 * https://github.com/gajus/react-aux
 *
 * @param {{ children: any }} props
 * @returns {T}
 */
function aux<T>(props: { children: any }): T {
  return props.children;
}

module.exports = aux;



// WEBPACK FOOTER //
// ./src/utils/react-aux.js